import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['adElement', 'fallback'];

  initialize() {
    this.checkAndLoadAd = this.checkAndLoadAd.bind(this);
    this.handleAdEmpty = this.handleAdEmpty.bind(this);
    this.adLoaded = false;
  }

  connect() {
    // Check periodically if dropdown is open
    this.checkInterval = setInterval(this.checkAndLoadAd, 1000);
  }

  disconnect() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    if (this.hasAdElementTarget) {
      this.adElementTarget.removeEventListener('gpt:slotOnload', this.handleAdEmpty);
    }
  }

  checkAndLoadAd() {
    if (this.adLoaded) return;

    // Check if dropdown is visible
    const dropdown = this.element.closest('[data-controller*="dropdown"]');

    if (dropdown) {
      const controller = this.application.getControllerForElementAndIdentifier(dropdown, 'dropdown');
      if (controller && controller.isVisibleValue) {
        this.loadAd();
      }
    }
  }

  loadAd() {
    if (this.adLoaded) return;

    // Listen for ad render to check if it's empty
    if (this.hasAdElementTarget) {
      this.adElementTarget.addEventListener('gpt:slotRenderEnded', this.handleAdEmpty);
    }

    // Add the native-ad controller to the ad element
    this.adElementTarget.dataset.controller = 'native-ad';

    this.adLoaded = true;
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  handleAdEmpty(event) {
    // If the ad slot is empty, show the fallback
    if (event.detail?.isEmpty) {
      this.adElementTarget.style.display = 'none';
      if (this.hasFallbackTarget) {
        this.fallbackTarget.style.display = 'block';
      }
    }
  }
}
